namespace TabAurous.ProductDevelopment {
    export namespace PDQuotationService {
        export const baseUrl = 'ProductDevelopment/Estimation';

        export declare function Create(request: Serenity.SaveRequest<PDQuotationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PDQuotationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PDQuotationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PDQuotationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SubmitQuotation(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ApproveQuotation(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/Estimation/Create",
            Update = "ProductDevelopment/Estimation/Update",
            Delete = "ProductDevelopment/Estimation/Delete",
            Retrieve = "ProductDevelopment/Estimation/Retrieve",
            List = "ProductDevelopment/Estimation/List",
            SubmitQuotation = "ProductDevelopment/Estimation/SubmitQuotation",
            ApproveQuotation = "ProductDevelopment/Estimation/ApproveQuotation"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'SubmitQuotation', 
            'ApproveQuotation'
        ].forEach(x => {
            (<any>PDQuotationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
